import React, { Component } from 'react';
import { lifecycle } from 'recompose';
import { Divider } from 'rebass';
import {
  Department,
  FacultyItem,
  UniversityItem,
  ScoreBox,
  ScoreBoxList,
  ExamReq,
  Text,
} from '@tcaster/tcaster-web-lib';

import AppContainer from '../AppContainer';

const MOCK_SUBJECT = [
  {
    subject: 'GPAX',
    conditions: 'ขั้นต่ำ 2.0',
    percent: '20%',
  },
  {
    subject: 'GAT',
    percent: '15%',
  },
  {
    subject: 'PAT 1',
    percent: '15%',
  },
  {
    subject: 'PAT 2',
    percent: '20%',
  },
  {
    subject: 'PAT 3',
    percent: '30%',
  },
  {
    subject: 'PAT 4',
    percent: '30%',
  },
  {
    subject: 'ONET วิทย์,ONET คณิต,ONET อังกฤษ',
    percent: '30%',
  },
];

const MOCK_SCORES = [
  {
    score: 20888,
    scoreLabel: 'คะแนนต่ำสุด 61',
  },
  {
    score: 21288,
    scoreLabel: 'คะแนนเฉลี่ย 61',
  },
  {
    score: 23409,
    scoreLabel: 'คะแนนสูงสุด 61',
  },
];
const MOCK_SCORES_EMPTY = [
  {
    noDataText: '-',
    scoreLabel: 'คะแนนต่ำสุด 61',
  },
  {
    noDataText: '-',
    scoreLabel: 'คะแนนเฉลี่ย 61',
  },
  {
    noDataText: '-',
    scoreLabel: 'คะแนนสูงสุด 61',
  },
];

const PlaygroundView = ({ location, menus }) => (
  <AppContainer menus={menus}>
    <Text fontWeight="bold">Playground component test {location && location.pathname}</Text>
    <Divider width={1} color="grey" />

    <Text fontWeight="300">Prompt พร้อมท์ light 300</Text>
    <Text>Prompt พร้อมท์ normal 400</Text>
    <Text fontWeight="bold">Prompt พร้อมท์ bold 500</Text>
    <Divider width={1} color="grey" />

    <Department department="test เทสสาขา" faculty="test faculty คณะ" university="test uni" />
    <Department
      university="จุฬาลงกรณ์มหาวิทยาลัย"
      faculty="คณะวิศวกรรมศาสตร์"
      department="สาขาวิศวกรรมทั่วไป"
      rounds={[false, false, true, false, false]}
    />
    <Divider width={1} color="grey" />
    <FacultyItem title="test คณะวิศวกรรมศาสตร์" />
    <Divider width={1} color="grey" />
    <FacultyItem title="test คณะวิศวกรรมศาสตร์" onClick={e => console.log('faculty click')} />
    <Divider width={1} color="grey" />
    <UniversityItem title="test จุฬาลงกรณ์มหาวิทยาลัย" circleColor="#afd" initials="CU" />
    <Divider width={1} color="grey" />
    <ExamReq reqs={MOCK_SUBJECT} />
    <Divider width={1} color="grey" />
    <ScoreBoxList scores={MOCK_SCORES} />
    <Divider width={1} color="grey" />
    <ScoreBoxList scores={MOCK_SCORES_EMPTY} />
    <Divider width={1} color="grey" />
    <ScoreBox score={18934} />
    <ScoreBox score={19305} large topLabel label={`คะแนนของคุณคือ`} textAlign={'right'} />
    <ScoreBox score={67.132534} type="meds" label={`คะแนนกสพท.จ้า`} />
  </AppContainer>
);

const lf = lifecycle({
  componentDidMount() {
    console.log('cdm', this.props);
  },
});

export default lf(PlaygroundView);
